import {Component, Inject, OnInit} from '@angular/core';
import {IContactItem} from '../../store/models/contact.model';
import {DIALOG_COMPONENT, DialogComponent} from '../../shared/ui/dialog/dialog.component';
import {DataSourceParams, ITableColumn} from '../../store/models/table.model';
import {ApiDataSource} from '../../datasources/api.datasrouce';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ButtonColor, ButtonSize} from '../../store/models/button.model';
import {SelectionChange} from '@angular/cdk/collections';
import {forkJoin, Observable} from 'rxjs';
import {ContactsService} from '../../store/services/contacts.service';
import {Store} from '@ngrx/store';
import {IReducers} from '../../store/reducers';
import {openSnackbar} from '../../store/actions/page.action';
import {TableComponent} from '../../shared/ui/table/table.component';
import {UserType} from "../../store/models/user.model";

const ACTION = 'Multiple Contacts, Removed by User';

@Component({
  selector: 'app-remove-contacts-from-domain-dialog',
  templateUrl: './remove-contacts-from-domain-dialog.component.html',
  styleUrls: ['./remove-contacts-from-domain-dialog.component.scss'],
})
export class RemoveContactsFromDomainDialogComponent implements OnInit {

  domain: string;
  userType: UserType;
  accountId: number;
  tableComponent: TableComponent;

  tableColumns: ITableColumn<IContactItem>[];

  dataSource: ApiDataSource<IContactItem>;

  dataSourceParams: DataSourceParams;

  contacts: IContactItem[] = [];

  tableReady: boolean;

  selectedContacts: IContactItem[] = [];

  totalItems = 0;

  contactId: number;

  constructor(
    private readonly httpClient: HttpClient,
    @Inject(DIALOG_COMPONENT) private readonly dialogComponent: DialogComponent,
    private readonly contactsService: ContactsService,
    private readonly store$: Store<IReducers>,
  ) {
  }

  ngOnInit(): void {
    if (this.domain.length <= 0) {
      this.dialogComponent.closeDialog();
    }

    this.tableColumns = [
      {
        id: 'contact_firstname',
        title: 'Contact',
        sortable: true,
        renderer: (c: IContactItem) => {
          return `${c.contact_firstname || ''} ${c.contact_lastname || ''}`;
        },
      },
      {
        id: 'contact_email',
        title: 'Email',
      },
      {
        id: 'contact_status',
        title: 'Status',
      },
    ];
    this.dataSource = new ApiDataSource<IContactItem>(this.httpClient, environment.apiUrl + '/v1/contacts' + (this.userType === UserType.VSM ? ('?account_id=' + this.accountId) : ''));
    this.dataSource.onDataLoaded()
      .subscribe(data => {
        if (this.totalItems !== data.length) {
          this.totalItems = data.length;
        }
      });
    this.dataSourceParams = {
      page: 1,
      pageSize: 10,
      sortAttr: 'id',
      sortDir: 'desc',
      filters: {
        search: this.domain,
        exclude: this.contactId.toString()
      },
    };

    this.dialogComponent.setButtons([
      {
        text: 'No',
        actAsClose: true,
        color: ButtonColor.ORANGE,
        size: ButtonSize.NORMAL,
        onClick: dialog => {
          dialog.close();
          this.dialogComponent.closeDialog();
        }
      },
      {
        text: 'Yes',
        size: ButtonSize.NORMAL,
        color: ButtonColor.GREEN,
        onClick: () => {
          const subscriptions: Observable<any>[] = [];
          for (const contact of this.selectedContacts) {
            subscriptions.push(this.contactsService.quickResponse({
              contact_id: contact.contact_id,
              action: ACTION,
              update: true,
              message: ACTION,
            }, 'inactive'));
          }

          if (subscriptions.length) {
            forkJoin(subscriptions)
              .subscribe(result => {
                this.store$.dispatch(openSnackbar({
                  snackbarData: {
                    data: {
                      message: 'Contacts were successfully moved to Inactive',
                      type: 'success',
                    },
                  },
                }));
                this.dialogComponent.closeDialog();
              });
          }
        },
      },
    ]);

    this.tableReady = true;
  }

  onRowSelected(contact: SelectionChange<IContactItem>) {
    this.selectedContacts = contact.source.selected;
  }
}
